<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="md-layout">
                    <div class="md-layout-item md-small-size-50 md-medium-size-50 md-xsmall-size-100 md-size-33">
                        <div class="bg-color" style="margin: 0px; margin-top:15px;">
                            <div class="media-body text-xs-left float-right" id="calories-value"
                                style="max-width: 445px; border-radius: 4px; position:relative;"
                                >
                                <h3 class="card-value" id="calories-text" style="color: rgb(130, 130, 130);">{{
                                    TotalAdminCount }}</h3>
                                <div id="foodimg"><span class="card-text" id="calories-subtitle"
                                        style="color: rgb(130, 130, 130);">Total Admins</span>
                                    <span id="food-img" class="icon-user"
                                        style="font-size: 65px; margin-right: 3%; margin-bottom: 2%; color: rgb(153, 147, 147);"><i
                                        class="fas fa-tasks"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout-item md-small-size-50 md-medium-size-50 md-xsmall-size-100 md-size-33">
                        <div class="bg-color" style="margin: 0px; margin-top:15px;">
                            <div class="media-body text-xs-left float-right" id="calories-value"
                                style="max-width: 445px; border-radius: 4px; position:relative;"
                                v-on:click="OpenUserPage()">
                                <h3 class="card-value" id="calories-text" style="color: rgb(130, 130, 130);">{{
                                    TotalUserCount }}</h3>
                                <div id="foodimg"><span class="card-text" id="calories-subtitle"
                                        style="color: rgb(130, 130, 130);">Total Users</span>
                                    <span id="food-img" class="icon-user"
                                        style="font-size: 65px; margin-right: 3%; margin-bottom: 2%; color: rgb(153, 147, 147);"><i
                                            class="fas fa-users"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { authMixin } from "../../../../components/superAdmin/SuperAdminStore";
import api, { setAuthToken } from "../../../../components/apiConfig";
import Cookies from "js-cookie";

export default {
    mixins: [authMixin],
    props: {
        tableHeaderColor: {
            type: String,
            default: "",
        },
     
    },
    created() {
        this.checkAuthorization();
    },

    data() {
        return {
            taskFormHeader: "",
            loading: "",
            TotalAdminCount: 0,

            TotalUserCount: 0,
            title: "Dashboard",

        };
    },
    mounted() {
        this.getSuperAdminDashboardDetails();
    },
    methods: {
        async getSuperAdminDashboardDetails() {
            this.loading = "Loading...";
            try {
                const token = Cookies.get("jwt");
                setAuthToken(token);
                let userCookie = Cookies.get("user");
                userCookie = userCookie ? JSON.parse(userCookie) : null;
                // this.UserName = userCookie.Username;
                const response = await api.get(
                    `/api/superAdmin/get-super-admin-dashboard-details`
                );
                if (response.data) {
                    console.log(response.data)
                    // get data
                    this.TotalAdminCount = response.data[0].AdminCount;
                    this.TotalUserCount = response.data[0].UserCount;
                    // console.log("taskcount", this.TotalTaskCount);
                } else {
                    // Handle case where no data are found
                }
            } catch (error) {
                // Handle API error
                setTimeout(() => {
                    this.getSuperAdminDashboardDetails(); // Retry after a delay
                }, 2000);
            } finally {
                this.loading = "No data found.";
            }
        },

    },
};
</script>

<style scoped>
.close-icon {
    cursor: pointer;
    float: right;
    font-size: 30px;
    margin-top: -10px;
}

.expired-row {
    background-color: #dc8484;
    border-bottom: 1px solid #eee;
}

.table-cell {
    font-size: 1.0625rem;
    padding-bottom: 10px;
    font-weight: 500;
}

.modal-backdrop.show {
    opacity: 0;
    display: none;
}

#tab-posts {
    margin-left: 20px;
    overflow: auto;
}

#tab-Dues {
    overflow-x: auto;
}

.md-tabs-navigation {
    padding-left: 100px !important;
}

.bg-color {
    background: white;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .14);
    margin: 25px 0;
    padding: 6px;
}

.main-panel>.content {
    padding-top: 0px !important;
}

.Count-header {
    font-size: 14px;
    font-weight: 600;
}

#tab-Dues {
    margin-left: -20px !important;
}

.dropdown {
    width: 100%;
    height: 36px;
    padding: 7px 0;
    font-size: 14px;
    line-height: 1.428571429;
    border-color: #D2D2D2;
}

#tab-posts {
    margin-left: 20px;
}

.nav-btn {
    color: #fff !important;
    padding: 6px;
    margin: 4px;
    border-radius: 5px;
    background: #0d6efd;
    font-weight: 400 !important;
}

.break {
    display: none;
}

@media screen and (max-width:700px) {
    .break {
        display: block;
    }
}

@media screen and (max-width:595px) {
    .nav-btn {
        padding: 4px;
        font-size: 13px;
        margin: 2px;
    }
}

/* @media screen and (max-width:510px) {
    .nav-btn{
  display: none;
  }
  } */

#calories-text {
    padding-left: 5%;
}

.card-value {
    font-weight: 400;
    font-size: 32px;
    color: #727272;
    margin-bottom: 0px;
    margin-top: 10px;
    letter-spacing: 0;
}

#calories-subtitle {
    padding-left: 5%;
}

.card-text {
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0;
    color: #303030;
}

.icon-user {
    position: absolute;
    right: 0px;
    top: 5px;
}

.media-body {
    cursor: pointer;
}

.media-body:hover h3,
.media-body:hover i {
    color: #0d6efd !important;
}

.media-body:hover .card-text {
    color: #555 !important;
}

.task-table {
    width: 100%;
}

@media screen and (min-width:990px) and (max-width: 1185px) {
    .task-table {
        width: 1100px;
        overflow-x: auto
    }
}

@media screen and (max-width: 890px) {
    .task-table {
        width: 830px;
        overflow-x: auto
    }
}
</style>